import request from '../helpers/request'

const DEFAULT_ENDPOINTS = {
  phoneUrl: '/phone-verification/',
  checkCodeUrl: '/check-code/'
}

export default {
  verifyPhone: async ({ phone, url }) => {
    const endpoint = url || DEFAULT_ENDPOINTS.phoneUrl
    const { data } = await request.post(endpoint, { phone })
    return data
  },
  verifyCode: async ({ phone, code, url, remember, source }) => {
    const endpoint = url || DEFAULT_ENDPOINTS.checkCodeUrl
    const { data } = await request.post(endpoint, { phone, code, remember, source })
    return data
  }
}
